<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>基本設定</template>
      <template v-slot:annotation>
        システム利用に必要な基本設定を登録します
      </template>
    </PageHeader>

    <v-row>
      <v-tabs v-model="tab" grow show-arrows>
        <v-tab>組織情報設定</v-tab>
        <v-tab v-if="isJinji">等級設定</v-tab>
        <v-tab>部署設定</v-tab>
        <v-tab>役職設定</v-tab>
        <v-tab v-if="isJinji">評価記号設定</v-tab>
        <v-tab v-if="isJinji">行動要素設定</v-tab>
        <v-tab v-if="isJinji">ランク設定</v-tab>
      </v-tabs>
    </v-row>

    <Organization v-if="tab === 0" />

    <p v-if="isJinji"><Grade v-if="tab === 1" /></p>

    <p v-if="isJinji"><Department v-if="tab === 2" /></p>
    <p v-else><Department v-if="tab === 1" /></p>

    <p v-if="isJinji"><Positon v-if="tab === 3" /></p>
    <p v-else><Positon v-if="tab === 2" /></p>

    <p v-if="isJinji"><EvaluationSymbol v-if="tab === 4" /></p>
    <p v-if="isJinji"><BehavioralElement v-if="tab === 5" /></p>
    <p v-if="isJinji"><RankSetting v-if="tab === 6" /></p>
  </v-container>
</template>

<script>
import Organization from '@/components/pages/Manages/Organization.vue';
import Department from '@/components/pages/Manages/Department.vue';
import Positon from '@/components/pages/Manages/Positon.vue';
import Grade from '@/components/pages/Manages/Grade.vue';
import EvaluationSymbol from '@/components/pages/Manages/EvaluationSymbol.vue';
import BehavioralElement from '@/components/pages/Manages/BehavioralElement.vue';
import RankSetting from '@/components/pages/Manages/RankSetting.vue';
import config from '../../const.js';
import { getSessionStorageItem } from '@/common.js';

export default {
  components: {
    Organization,
    Department,
    Positon,
    Grade,
    EvaluationSymbol,
    BehavioralElement,
    RankSetting,
  },
  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: '基本設定',
          route: 'BasicSetting',
        },
      ],

      tab: 0,
      expiration: '0',
      isPurasunoki: false,
      isJinji: false,
    };
  },
  created() {
    let userInfo = getSessionStorageItem();
    if (userInfo) {
      this.expiration = userInfo.ORGANIZATION_EXPIRATION;
    }
    if (this.expiration == config.EXPIRATION_PURASUNOKI) {
      // プラスの氣
      this.isPurasunoki = true;
      this.isJinji = false;
    } else if (this.expiration == config.EXPIRATION_JINJI) {
      // 人事考課
      this.isPurasunoki = false;
      this.isJinji = true;
    } else {
      // 両方
      this.isPurasunoki = true;
      this.isJinji = true;
    }
  },

  methods: {},
};
</script>
